/*
 * WP8 — password policy (finding W2).
 *
 * Single client-side source of truth, mirroring the API's Password::defaults
 * rule so the user gets immediate feedback before submitting: at least 12
 * characters, mixed case, and a number. The breached-password check (Have I
 * Been Pwned) is enforced server-side only and surfaced via the API response.
 */

export const PASSWORD_MIN_LENGTH = 12;

export interface PasswordChecks {
    minLength: boolean;
    mixedCase: boolean;
    number: boolean;
}

export const checkPassword = (password: string): PasswordChecks => {
    const value = password || '';

    return {
        minLength: value.length >= PASSWORD_MIN_LENGTH,
        mixedCase: /[a-z]/.test(value) && /[A-Z]/.test(value),
        number: /[0-9]/.test(value),
    };
};

export const isPasswordValid = (password: string): boolean => {
    const checks = checkPassword(password);

    return checks.minLength && checks.mixedCase && checks.number;
};

export const PASSWORD_REQUIREMENTS: { key: keyof PasswordChecks; label: string }[] = [
    { key: 'minLength', label: 'At least 12 characters long' },
    { key: 'mixedCase', label: 'Contain both upper and lower case letters' },
    { key: 'number', label: 'Contain at least one number' },
];
